import {Vue} from "ui.vue";
import {MapMixin} from "./map-mixin";
import {VideoMixin} from "./video-mixin";
import {Request} from "citrus.plugins.request";
import SlideUpDown from 'vue-slide-up-down';

Vue.component('vue-slide-up-down', SlideUpDown);

export default {
	name: "CitrusComponentElementList",
	mixins: [
		MapMixin,
		VideoMixin,
	],
	data: () => {
		return {
			loading: false,
			loadingSection: false,
			items: false,
			load: {
				start: false,
				pageNumber: 1,
				isMoreLink: false
			},
			ajaxParams: {
				parameters: "",
				rewrite: {},
				filter: {}
			},
			pagination: false,
			locPrefix: "CC_ELEMENT_LIST_",
			curSectionId: "",
			curSectionCode: "",
			sortByParam: "SORT_BY1",
			sortOrderParam: "SORT_ORDER1",
			currentTag: ''
		};
	},
	created() {
		BX.addCustomEvent('CatalogSectionDefault:sort', this.onSort);
		BX.addCustomEvent('CatalogSectionDefault:filter', this.onFilter);
	},
	mounted() {
		if(typeof gridMasonryUpdate === "function" &&  typeof newsGridInit === "function") {
			newsGridInit();
			gridMasonryUpdate();
		}
	},
	methods: {
		detailPageUrl(url) {
			return null === url || !url ? "javascript:void(0)" : url;
		},
		changePage(data) {
			this.load.pageNumber = data.hasOwnProperty("pageNumber") ? data["pageNumber"] : 1;
			this.load.isMoreLink = data.hasOwnProperty("isMoreLink") ? data["isMoreLink"] : false;

			this.refresh();
		},
		changeSection(newSectionId, newSectionCode) {
			this.loadingSection = true;
			this.curSectionId = newSectionId;
			this.curSectionCode = newSectionCode;

			if(this.$refs.sectionPagination) {
				if(this.$refs.sectionPagination.observer != null) {
					this.$refs.sectionPagination.observer.disconnect();
				}
				this.$refs.sectionPagination.initAutoload();
			}

			this.onFilter({'IBLOCK_SECTION_ID': this.curSectionId, 'TAGS': ""});
		},
		onSort(sort, order) {
			if (!this.ajaxParams.hasOwnProperty('rewrite')) {
				this.ajaxParams.rewrite = {};
			}

			this.ajaxParams.rewrite[this.sortByParam] = sort;
			this.ajaxParams.rewrite[this.sortOrderParam] = order;

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		onFilter(filter) {
			if (!this.ajaxParams.hasOwnProperty('filter')) {
				this.ajaxParams.filter = {};
			}

			this.ajaxParams.filter = Object.assign({}, this.ajaxParams.filter, filter);

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		showTag(tag) {
			this.currentTag = '';

			if(tag.length > 0) {
				this.currentTag = '#' + tag;
			}

			BX.onCustomEvent('tag', [tag]);
		},
		refresh() {
			if (this.loading || !this.pagination) {
				return;
			}

			this.loading = true;

			this.ajaxParams["nav"] = {
				param: this.pagination.pageParam,
				value: this.load.pageNumber
			};

			this.load.start = true;

			(new Request())
				.setModeModule()
				.setAction("citrus:component.component.execute")
				.setData(this.ajaxParams)
				.send()
				.then((response) => {
					this.loading = false;
					this.loadingSection = false;

					if (this.load.isMoreLink) {
						this.items = this.items.concat(response.items);
					} else {
						this.items = response.items;
						//this.scrollToElement();
					}

					this.$set(this, "pagination", response.pagination);

					this.load.start = false;
					BX.onCustomEvent("Citrus.Component.Element.List:ajaxLoadDataCompleted", [response.items]);
				}, (error) => {
					console.error(error);
					this.load.start = false;
					this.loading = false;
					this.loadingSection = false;
				});
		},
		async scrollToElement() {
			let slide = this.$el;
			if (!slide) {
				return;
			}

			let top = window.scrollY + slide.getBoundingClientRect().y;
			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
		show(item) {
			item.active = !item.active;
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases(this.locPrefix);
		}
	}
};
